
export const TRANSCRIPTION_SESSION_CREATE_REQUEST = 'TRANSCRIPTION_SESSION_CREATE_REQUEST';
export const TRANSCRIPTION_SESSION_CREATE_SUCCESS = 'TRANSCRIPTION_SESSION_CREATE_SUCCESS';
export const TRANSCRIPTION_SESSION_CREATE_ERROR = 'TRANSCRIPTION_SESSION_CREATE_ERROR';

export const TRANSCRIPTION_UPDATE_TEXT_REQUEST = 'TRANSCRIPTION_UPDATE_TEXT_REQUEST';
export const TRANSCRIPTION_UPDATE_TEXT_SUCCESS = 'TRANSCRIPTION_UPDATE_TEXT_SUCCESS';
export const TRANSCRIPTION_UPDATE_TEXT_ERROR = 'TRANSCRIPTION_UPDATE_TEXT_ERROR';

export const TRANSCRIPTION_PROCESS_REQUEST = 'TRANSCRIPTION_PROCESS_REQUEST';
export const TRANSCRIPTION_PROCESS_SUCCESS = 'TRANSCRIPTION_PROCESS_SUCCESS';
export const TRANSCRIPTION_PROCESS_ERROR = 'TRANSCRIPTION_PROCESS_ERROR';

export const TRANSCRIPTION_APPLY_REQUEST = 'TRANSCRIPTION_APPLY_REQUEST';
export const TRANSCRIPTION_APPLY_SUCCESS = 'TRANSCRIPTION_APPLY_SUCCESS';
export const TRANSCRIPTION_APPLY_ERROR = 'TRANSCRIPTION_APPLY_ERROR';

export const TRANSCRIPTION_GET_SESSION_REQUEST = 'TRANSCRIPTION_GET_SESSION_REQUEST';
export const TRANSCRIPTION_GET_SESSION_SUCCESS = 'TRANSCRIPTION_GET_SESSION_SUCCESS';
export const TRANSCRIPTION_GET_SESSION_ERROR = 'TRANSCRIPTION_GET_SESSION_ERROR';

export const TRANSCRIPTION_AUDIO_UPLOAD_REQUEST = 'TRANSCRIPTION_AUDIO_UPLOAD_REQUEST';
export const TRANSCRIPTION_AUDIO_UPLOAD_SUCCESS = 'TRANSCRIPTION_AUDIO_UPLOAD_SUCCESS';
export const TRANSCRIPTION_AUDIO_UPLOAD_ERROR = 'TRANSCRIPTION_AUDIO_UPLOAD_ERROR';

export const TRANSCRIPTION_CORRECT_TEXT_REQUEST = 'TRANSCRIPTION_CORRECT_TEXT_REQUEST';
export const TRANSCRIPTION_CORRECT_TEXT_SUCCESS = 'TRANSCRIPTION_CORRECT_TEXT_SUCCESS';
export const TRANSCRIPTION_CORRECT_TEXT_ERROR = 'TRANSCRIPTION_CORRECT_TEXT_ERROR';

export const TRANSCRIPTION_RESET = 'TRANSCRIPTION_RESET';

export const TRANSCRIPTION_DIALOG_OPEN = 'TRANSCRIPTION_DIALOG_OPEN';
export const TRANSCRIPTION_DIALOG_CLOSE = 'TRANSCRIPTION_DIALOG_CLOSE';

export const MODAL_TRANSCRIPTION = 'MODAL_TRANSCRIPTION';

export const MODAL_FREE_MODE_TEMPLATE_PICKER = 'MODAL_FREE_MODE_TEMPLATE_PICKER';

export const TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_REQUEST = 'TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_REQUEST';
export const TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_SUCCESS = 'TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_SUCCESS';
export const TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_ERROR = 'TRANSCRIPTION_FETCH_FREE_MODE_TEMPLATES_ERROR';
export const TRANSCRIPTION_SET_SELECTED_TEMPLATE = 'TRANSCRIPTION_SET_SELECTED_TEMPLATE';
export const TRANSCRIPTION_CLEAR_SELECTED_TEMPLATE = 'TRANSCRIPTION_CLEAR_SELECTED_TEMPLATE';

export const TRANSCRIPTION_CLEAR_PENDING = 'TRANSCRIPTION_CLEAR_PENDING';
